"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EventManager = void 0;
class EventManager {
    constructor() {
        this._triggers = {};
    }
    on(event, callback) {
        if (!this._triggers[event]) {
            this._triggers[event] = [];
        }
        this._triggers[event].push(callback);
    }
    off(event, callback) {
        if (this._triggers[event]) {
            const index = this._triggers[event].indexOf(callback, 0);
            if (index > -1) {
                this._triggers[event].splice(index, 1);
            }
        }
    }
    trigger(event, params) {
        if (this._triggers[event]) {
            for (var i in this._triggers[event]) {
                this._triggers[event][i](params);
            }
        }
    }
}
exports.EventManager = EventManager;
